export const AGORA_APP_ID = 'c902493ba1624bce84860a7028761f3d'
// export const AGORA_APP_ID = 'e7ab3a19878f44ea8382a12bc62d9ab9'
// export const AGORA_APP_ID = '9f12f36b1ac346dd846736159cbfd132'
